// src/services/associationsServices.js

import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/associations`;

function getAuthConfig(config = {}) {
  const token = localStorage.getItem("token");

  return {
    ...config,
    headers: {
      ...config.headers,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
}

export const getAllAssociations = async () => {
  const response = await axios.get(
    `${apiUrl}/AllAssociations`,
    getAuthConfig(),
  );

  return Array.isArray(response.data) ? response.data : [];
};

export const countAssociations = async () => {
  const response = await axios.get(
    `${apiUrl}/CountAssociations`,
    getAuthConfig(),
  );

  return response.data;
};

export const countClientAssociations = async () => {
  const response = await axios.get(
    `${apiUrl}/CountClientAssociations`,
    getAuthConfig(),
  );

  return response.data;
};

export const getLatestAssociations = async () => {
  const response = await axios.get(
    `${apiUrl}/LastFiveAssociations`,
    getAuthConfig(),
  );

  return response.data;
};

export const getAssociationById = async (id) => {
  const response = await axios.get(
    `${apiUrl}/AssociationById/${id}`,
    getAuthConfig(),
  );

  return response.data;
};

export const getFavoriteAssociations = async () => {
  const response = await axios.get(
    `${apiUrl}/FavoriteAssociations`,
    getAuthConfig(),
  );

  return response.data;
};

export const getAssociationsByUserId = async (id) => {
  const response = await axios.get(
    `${apiUrl}/AssociationsByUserId/${id}`,
    getAuthConfig(),
  );

  return response.data;
};

export const saveAssociation = async (payload) => {
  const response = await axios.post(
    `${apiUrl}/addAssociation`,
    payload,
    getAuthConfig(),
  );

  return response.data;
};

export const updateAssociation = async (id, payload) => {
  const response = await axios.patch(
    `${apiUrl}/updateAssociation/${id}`,
    payload,
    getAuthConfig(),
  );

  return response.data;
};

export const patchAssociationFields = async (id, partial) => {
  return updateAssociation(id, partial);
};

export const deleteAssociation = async (id) => {
  const response = await axios.delete(
    `${apiUrl}/deleteAssociation/${id}`,
    getAuthConfig(),
  );

  return response.data;
};

export const getClientsKanbanBoard = async (params = {}) => {
  const response = await axios.get(
    `${apiUrl}/kanban/clients`,
    getAuthConfig({ params }),
  );

  return response.data;
};

export const moveAssociationKanban = async (id, payload = {}) => {
  const response = await axios.patch(
    `${apiUrl}/kanban/move/${id}`,
    payload,
    getAuthConfig(),
  );

  return response.data;
};